import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Cookies from "universal-cookie";
import PropTypes from "prop-types";

import {
  LifeSafer,
  Monitech,
  Guardian,
  QuickStart,
} from "../_helpers/BrandConstants";
import { brandColors } from "./brandedComponent/BrandedColors";
import { USA, Australia } from "@/_helpers/CountryConstants";
import { styled } from "@mui/material/styles";

const ColoredLink = styled(Link)(({ color }) => ({
  color: color,
}));

const Copyright = ({ isISA }) => {
  const version = process.env.VERSION;
  const { t } = useTranslation();
  const [brandWebsite, setBrandWebsite] = useState();
  const [brandName, setBrandName] = useState();
  const cookies = new Cookies();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const siteCountry = cookies.get("siteCountry") || USA;

  useEffect(() => {
    if (brand === LifeSafer && siteCountry === USA) {
      setBrandName("LifeSafer");
      setBrandWebsite("https://www.lifesafer.com/");
    } else if (brand === LifeSafer && siteCountry === Australia) {
      setBrandName("LifeSafer");
      setBrandWebsite("https://www.lifesafer.au/");
    } else if (brand === Guardian) {
      setBrandWebsite("https://www.guardianinterlock.com/");
      setBrandName("GuardianInterlock");
    } else if (brand === Monitech) {
      setBrandWebsite("https://monitechnc.com/");
      setBrandName("Monitech");
    } else if (brand === QuickStart) {
      setBrandWebsite("https://www.quickstartaz.com/");
      setBrandName("QuickStart");
    } else if (brand === LifeSafer && isISA) {
      setBrandWebsite("https://www.lifesaferisa.com/");
      setBrandName("LifeSafer");
    } else {
      setBrandWebsite("https://www.lifesafer.com/");
      setBrandName("LifeSafer");
    }
  }, [brand, siteCountry, isISA]);

  return (
    <Typography variant="body2" color="text.secondary" align="center">
      <span>{`Enrollment version ${version}`}</span>
      <br />
      {t("policies.copyrightLabel")}
      {" © "}
      <ColoredLink
        href={brandWebsite}
        target="_blank"
        rel="noopener noreferrer"
        color={brandColors[brand]?.secondary || "inherit"}
      >
        {brandName}
      </ColoredLink>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};

Copyright.propTypes = {
  isISA: PropTypes.bool,
};
export { Copyright };
